<template>
  <BreadCrumb PageTitle=" Liste des catégories d'activité"/>
    <ListeCategorieActivite />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeCategorieActivite from "@/components/CategorieActivite/ListeCategorieActivite.vue";

  
    export default defineComponent({
      name: "ListeCategorieActivitePage",
      components: {
        ListeCategorieActivite,
      },
    });
  </script>